const theme = {
  colors: {
    primary: '#2E5CAB',
    secondary: '#358bff',
    text: '#333333',
    lightText: '#666666',
    background: '#FFFFFF',
    accent: '#4CAF50',
    lightGray: '#F5F5F5',
    darkGray: '#2F2F2F'
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '1024px'
  }
};

export default theme;